module.exports = __webpack_public_path__ + "static/media/domainLinking.8dcc9a8c.svg";